import { EMPTY_SEARCH_RESULT, MUTATE_SEARCH_RESULT } from './types';

export default {
  [MUTATE_SEARCH_RESULT]: (state, payload) => {
    const {
      data: {
        award, event, post, shared_post, user, company,
      },
    } = payload;
    const mutatedResult = {
      companies: company,
      users: user,
      posts: [...post, ...shared_post].sort((a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()),
      events: [...event, ...award].sort((a, b) => new Date(b.start_date).getTime() - new Date(a.start_date).getTime()),
    };
    state.isHideNavItems = true;
    state.searchResults = mutatedResult;
  },
  [EMPTY_SEARCH_RESULT]: (state) => {
    state.searchResults = {};
    state.isHideNavItems = false;
  },
};
